<template>
  <div v-if="isFullPage" class="fixed inset-0 z-50 flex items-center justify-center bg-surface-950/40 backdrop-blur-md">
    <div class="bg-white dark:bg-surface-900 rounded-2xl p-8 shadow-elevation-3 dark:shadow-glass-lg flex flex-col items-center gap-5 border border-surface-200/50 dark:border-surface-800/50 animate-scale-in">
      <div class="relative">
        <!-- Outer ring -->
        <div class="h-12 w-12 rounded-full border-[3px] border-surface-200 dark:border-surface-700"></div>
        <!-- Spinning arc -->
        <div class="absolute inset-0 h-12 w-12 rounded-full border-[3px] border-transparent border-t-accent-500 animate-spin"></div>
        <!-- Center dot -->
        <div class="absolute inset-0 flex items-center justify-center">
          <div class="h-2 w-2 rounded-full bg-accent-500 animate-pulse-soft"></div>
        </div>
      </div>
      <p v-if="message" class="text-sm font-medium text-surface-600 dark:text-surface-400">{{ message }}</p>
    </div>
  </div>
  <div v-else class="flex items-center justify-center" :class="containerClass">
    <div class="relative">
      <div :class="['rounded-full border-[3px] border-surface-200 dark:border-surface-700', sizeClass]"></div>
      <div :class="['absolute inset-0 rounded-full border-[3px] border-transparent border-t-accent-500 animate-spin', sizeClass]"></div>
    </div>
    <p v-if="message" class="ml-3 text-sm font-medium text-surface-600 dark:text-surface-400">{{ message }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  isFullPage: {
    type: Boolean,
    default: false
  },
  message: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value)
  },
  color: {
    type: String,
    default: 'primary'
  },
  containerClass: {
    type: String,
    default: 'p-4'
  }
})

const sizeClass = computed(() => {
  const sizes = {
    sm: 'h-5 w-5',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }
  return sizes[props.size]
})
</script>
